import {
  Component,
  EventEmitter,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { DossierAbandonOutputData } from '@sc/data-access-models';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '../button';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { IconComponent } from '../icon';

@Component({
  selector: 'sc-abandon-dossier-fitter-sheet',
  styleUrls: ['./abandon-dossier-fitter-sheet.component.scss'],
  encapsulation: ViewEncapsulation.None,
  template: `
    <div class="abandon-dossier-container">
      <div class="close">
        <button
          type="button"
          class="close-btn"
          (click)="onButtonClick('cancel')"
        >
          <span class="sr_only">{{
            'GlobalApplicativeConstants.accessibility.closeDialog'
              | translate
                : { dialogTitle: 'AbandonDossierSheet.mainTitle' | translate }
          }}</span>
          <sc-icon name="close"></sc-icon>
        </button>
      </div>
      <span class="delete-icon">
        <sc-icon name="delete"></sc-icon>
      </span>
      <h1
        mat-dialog-title
        id="abandon-dossier-fitter-title-id"
        [innerHTML]="'AbandonDossierSheet.mainTitle' | translate"
      ></h1>
      <h2>{{ 'AbandonDossierSheet.subTitle' | translate }}</h2>
      <textarea
        matInput
        #abandonedcommenttext
        [(ngModel)]="abandonmentComment"
      ></textarea>
      <sc-button
        id="abandonBtn"
        buttonType="error"
        [disabled]="!abandonmentComment"
        (click)="onButtonClick('success')"
        >{{ 'AbandonDossierSheet.abandonButton' | translate }}</sc-button
      >

      <sc-button
        id="cancelBtn"
        buttonType="primary"
        (click)="onButtonClick('cancel')"
        >{{ 'AbandonDossierSheet.cancelButton' | translate }}</sc-button
      >
    </div>
  `,
  imports: [
    IconComponent,
    MatInputModule,
    ReactiveFormsModule,
    FormsModule,
    ButtonComponent,
    TranslateModule,
  ],
})
export class AbandonDossierFitterSheetComponent {
  @Output()
  private readonly abandonCommentResult = new EventEmitter<DossierAbandonOutputData>();

  abandonmentComment: string;

  onButtonClick(clickEvent) {
    if (clickEvent === 'success') {
      this.abandonCommentResult.emit({
        type: clickEvent,
        comment: this.abandonmentComment,
      });
    } else {
      this.abandonCommentResult.emit({ type: clickEvent });
    }
  }
}
